import type { TVersion } from './types';

export const isMobileDeviceByUserAgent = (userAgent: string | null) => {
    if (!userAgent) return false;

    const regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    return regex.test(userAgent);
};

/**
 * Compares two version strings and determines if version A is newer, older, or the same as version B.
 *
 * @param a - The first version string to compare, in the format "x.y.z".
 * @param b - The second version string to compare, in the format "x.y.z".
 * @returns 1 if version A is newer than version B, -1 if version A is older than version B, and 0 if they are the same.
 */
export function compareVersion(a: TVersion, b: TVersion): 1 | 0 | -1 {
    const versionA = a.split('.').map(Number);
    const versionB = b.split('.').map(Number);
    for (let i = 0; i < versionA.length; i++) {
        if (versionA[i] > versionB[i]) return +1;
        if (versionA[i] < versionB[i]) return -1;
    }
    return 0;
}
